// Buy an asset off the shop. Pays cost from wallet, creates an AssetInstance, logs txn.

import type { GameState } from '../state/types.js';
import type { AssetDef } from '../config/types.js';
import { applyTxn } from '../ledger/append.js';

export type BuyAssetError = { code: 'INSUFFICIENT_CASH' | 'UNKNOWN_ASSET'; message: string };

export type BuyAssetOutcome = { state: GameState; assetInstanceId: string };

export function buyAsset(
  state: GameState,
  def: AssetDef,
  instanceId: string,
): { ok: true; value: BuyAssetOutcome } | { ok: false; error: BuyAssetError } {
  if (state.wallet.cash < def.cost) {
    return {
      ok: false,
      error: {
        code: 'INSUFFICIENT_CASH',
        message: `Need B$${def.cost} to buy ${def.name}, have B$${state.wallet.cash.toFixed(2)}.`,
      },
    };
  }

  const next = applyTxn(state, {
    type: 'asset_buy',
    amount: -def.cost,
    category: 'capital',
    note: `Bought ${def.name}`,
  });

  const withAsset: GameState = {
    ...next,
    assets: [
      ...next.assets,
      {
        id: instanceId,
        defId: def.id,
        costPaid: def.cost,
        weeklyYield: def.weeklyYield,
        weeksOwned: 0,
      },
    ],
  };

  return { ok: true, value: { state: withAsset, assetInstanceId: instanceId } };
}
